var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-with-lines"},[_c('div',{staticClass:"line"}),_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }